// import React, { Component } from "react";
// import ListingPage from "../2/Controls/ListingPage";
// import Window from "../2/Controls/Window";
// import AddCampaign from "./AddCampaign";

// class CampaignList extends Component {

//   constructor(props) {

//     super(props);

//     this.state = {

//       list: [],
//       totalCount: 0,
//       loading: false,
//       page: 1,
//       pageSize: 25,

//       showDelete: false,
//       showAddCampaign: false,
//       selectedRow: null,

//       listPageSettings: {

//         Title: "Campaigns",

//         Search: {
//           showSearch: false,
//         },

//         HeaderButtons: [
//           {
//             ButtonType: "Button",
//             Type: "primary",
//             Text: "New",
//             Icon: "add",
//             Action: "new"
//           }
//         ],

//         Columns: [
//           { Name: "Name", Type: "field", Columns: [{ Column: "Name" }] },

//           {
//             Name: "Type",
//             Type: "multiple",
//             Columns: [
//               { Column: "Type" },
//               { Column: "StartDate", Type: "date" },
//               { Column: "SlotDisplay" },
//             ],
//           },

//           {
//             Name: "Stores",
//             Type: "field",
//             Columns: [{ Column: "StoresDisplay" }],
//           },

//           {
//             Name: "Last Run",
//             Type: "multiple",
//             Columns: [
//               { Column: "Message" },
//               { Column: "Status", Label: "Status" },
//               { Column: "NoOfCustomers", Label: "Customer Count" },
//               { Column: "MessageLength", Label: "Message Length" },
//               { Column: "NoOfSMSSent", Label: "SMS Sent" },
//             ],
//           },

//           {
//             Name: "",
//             Type: "field",
//             ShowInMobile: true,
//             Columns: [
//               { Column: "Name" },
//               { Column: "Type" },
//               { Column: "StartDate", Type: "date" },
//               { Column: "Status", Label: "Status" },
//             ],
//           },
//         ],

//         RowButtons: [
//           {
//             ButtonType: "ImageButton",
//             Type: "edit",
//             Text: "Edit",
//             Icon: "edit"
//           },
//           {
//             ButtonType: "ImageButton",
//             Type: "delete",
//             Text: "Delete",
//             Icon: "delete"
//           }
//         ]
//       }
//     };
//   }

//   componentDidMount() {
//     this.loadData();
//   }

//   // =====================
//   // LOAD DATA
//   // =====================

//   loadData = async () => {

//     this.setState({ loading: true });

//     try {

//       let allCampaigns = await this.props.getCampaign(
//        this.props.user.user.RegistrationID
//       );

//       let campaigns = (allCampaigns || []).filter(e => !e.IsDeleted);

//       // get last run data
//       await Promise.all(
//         campaigns.map(async (obj) => {

//           let campaignToRun =
//             await this.props.getCampaignToRunByCampaignID(obj.key);

//           if (campaignToRun && campaignToRun.length > 0) {

//             let run = campaignToRun[0];

//             obj.CampaignToRunID = run.key;
//             obj.Message = run.Message || "";
//             obj.MessageLength = run.MessageLength || 0;
//             obj.NoOfCustomers = run.NoOfCustomers || 0;
//             obj.NoOfSMSSent = run.NoOfSMSSent || 0;
//             obj.Status = run.Status || "";
//             obj.LastRunOn = run.ActionOn || "";

//           }

//           // Slot Display
//           const slotMap = {
//             8: "8:00 - 10:00",
//             10: "10:00 - 12:00",
//             12: "12:00 - 14:00",
//             14: "14:00 - 16:00",
//             16: "16:00 - 18:00",
//             18: "18:00 - 20:00",
//             20: "20:00 - 22:00"
//           };

//           obj.SlotDisplay = slotMap[obj.Slot] || "";

//           // Stores Display
//           if (obj.AllStoresSelected) {

//             obj.StoresDisplay = "All stores";

//           } else if (obj.Stores && obj.Stores.length > 0) {

//             obj.StoresDisplay =
//               obj.Stores.map(s => s.label).join(", ");

//           } else {

//             obj.StoresDisplay = "";

//           }

//         })
//       );

//       this.setState({
//         list: campaigns,
//         totalCount: campaigns.length,
//         loading: false
//       });

//     } catch (error) {

//       console.error(error);

//       this.setState({ loading: false });

//       this.props.getToastr("Failed to fetch campaigns");

//     }
//   };


//   // =====================
//   // PAGINATION
//   // =====================

//   onNextClick = () => {

//     const totalPages =
//       Math.ceil(this.state.totalCount / this.state.pageSize);

//     if (this.state.page < totalPages) {

//       this.setState(
//         { page: this.state.page + 1 },
//         this.loadData
//       );

//     }
//   };


//   onPreviousClick = () => {

//     if (this.state.page > 1) {

//       this.setState(
//         { page: this.state.page - 1 },
//         this.loadData
//       );

//     }
//   };


//   onFirstClick = () => {

//     this.setState(
//       { page: 1 },
//       this.loadData
//     );
//   };


//   onLastClick = () => {

//     const totalPages =
//       Math.ceil(this.state.totalCount / this.state.pageSize);

//     this.setState(
//       { page: totalPages },
//       this.loadData
//     );
//   };


//   onRecordsPerPageCountChange = (size) => {

//     this.setState(
//       {
//         pageSize: Number(size),
//         page: 1
//       },
//       this.loadData
//     );
//   };


//   // =====================
//   // HEADER BUTTON
//   // =====================

//   onHeaderButtonClicked = (btn) => {

//     if (btn.Action === "new") {

//       this.setState({
//         showAddCampaign: true,
//         selectedRow: null
//       });

//     }
//   };


//   // =====================
//   // ROW BUTTON
//   // =====================

//   onRowButtonClicked = (btn, row) => {

//     if (btn.Type === "edit") {

//       this.setState({
//         showAddCampaign: true,
//         selectedRow: row
//       });

//     }

//     if (btn.Type === "delete") {

//       this.setState({
//         showDelete: true,
//         selectedRow: row
//       });

//     }
//   };


//   // =====================
//   // DELETE
//   // =====================

//   deleteRecord = async () => {

//     this.setState({
//       loading: true,
//       showDelete: false
//     });

//     await this.props.deleteCampaign(
//       this.state.selectedRow.key
//     );

//     this.props.getToastr(
//       "Campaign deleted successfully"
//     );

//     this.setState(
//       {
//         selectedRow: null,
//         loading: false
//       },
//       this.loadData
//     );
//   };


//   // =====================
//   // POPUP
//   // =====================

//   onClosePopup = () => {

//     this.setState({
//       showAddCampaign: false,
//       selectedRow: null
//     });

//   };


//   onPostPopupSave = () => {

//     this.setState(
//       {
//         showAddCampaign: false,
//         selectedRow: null
//       },
//       this.loadData
//     );

//   };


//   // =====================
//   // RENDER
//   // =====================
//   onPageChange = (page, pageSize) => {
//   console.log("page",page);
//   this.setState(
//     { page, pageSize },
//     () => {
//       this.loadData();
//     }
//   );
// };

//   render() {

//     return (

//       <>

//         <ListingPage

//           {...this.props}
//           onPageChange={this.onPageChange}

//           listPageSettings={{
//             ...this.state.listPageSettings
//           }}

//           list={this.state.list}

//           loading={this.state.loading}

//           totalItemsCount={this.state.totalCount}

//           recordFrom={
//             (this.state.page - 1)
//             * this.state.pageSize
//           }

//           itemsCountPerPage={
//             this.state.pageSize
//           }

//           onNextClick={this.onNextClick}

//           onPreviousClick={
//             this.onPreviousClick
//           }

//           onFirstClick={this.onFirstClick}

//           onLastClick={this.onLastClick}

//           onRecordsPerPageCountChange={
//             this.onRecordsPerPageCountChange
//           }

//           onHeaderButtonClicked={
//             this.onHeaderButtonClicked
//           }

//           onRowButtonClicked={
//             this.onRowButtonClicked
//           }

//         />


//         {/* DELETE */}

//         {this.state.showDelete && (

//           <Window

//             header="Delete"

//             modal

//             onClose={() =>
//               this.setState({
//                 showDelete: false
//               })
//             }

//             onButtonClick={(btn) => {

//               if (btn === "Yes")
//                 this.deleteRecord();

//               else
//                 this.setState({
//                   showDelete: false
//                 });

//             }}

//             buttons={[
//               {
//                 Type: "secondary",
//                 Text: "No",
//                 Align: "left"
//               },
//               {
//                 Type: "primary",
//                 Text: "Yes",
//                 Align: "right"
//               }
//             ]}

//           >

//             Are you sure you want to delete?

//           </Window>

//         )}


//         {/* ADD / EDIT */}

//         {this.state.showAddCampaign && (

//           <AddCampaign

//             {...this.props}

//             campaign={
//               this.state.selectedRow
//             }

//             onSave={
//               this.onPostPopupSave
//             }

//             onClose={
//               this.onClosePopup
//             }

//           />

//         )}

//       </>

//     );
//   }
// }

// export default CampaignList;




import React from "react";
import ListingPage from "../2/Controls/ListingPage";
import Window from "../2/Controls/Window";

function formatDateTime(isoString) {
  if (!isoString) {
    return null;
  }
  const date = new Date(isoString);

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  };

  return date.toLocaleString("en-US", options);
}

class CampaignList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      campaigns: [],
      loading: false,
      loadingStates: {},
      openDeleteConfirm: false,
      selectedCampaign: null,
      currentPage: 1,
      rowsPerPage: 25,
      totalCount: 0,
      deleteProcessing: false,
    };

    // Bind methods
    this.fetchData = this.fetchData.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleCancelDelete = this.handleCancelDelete.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
    this.getStatusBadge = this.getStatusBadge.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleRowsPerPageChange = this.handleRowsPerPageChange.bind(this);
    this.handleWindowButtonClick = this.handleWindowButtonClick.bind(this);
  }


  async fetchData() {
    this.setState({ loading: true });
    try {
      const response = await this.props.getCampaign(this.props.user.store.key);
      console.log(response, "response campaign");
      if (response.code == "0") {
        this.setState({
          campaigns: response.Campaigns,
          totalCount: response.Campaigns.length
        });
      } else {
        this.setState({ campaigns: [], totalCount: 0 });
      }
    } catch (err) {
      this.props.getToastr("Error fetching campaign:");
      console.error("Error fetching campaign:", err);
    } finally {
      this.setState({ loading: false });
    }
  }

  async handleStatusChange(id, status) {
    this.setState((prevState) => ({
      loadingStates: { ...prevState.loadingStates, [id]: true }
    }));

    try {
      const response = await this.props.updateCampaignStatus(id, status);
      if (response.code == "0") {
        await this.fetchData();
        this.props.getToastr(`Campaign status updated to ${status}`);
      } else {
        this.props.getToastr("Unable to toggle status of campaign");
      }
    } catch (err) {
      this.props.getToastr("Error updating campaign status");
      console.error("Error updating campaign status:", err);
    } finally {
      this.setState((prevState) => ({
        loadingStates: { ...prevState.loadingStates, [id]: false }
      }));
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  getStatusBadge(status) {
    const baseStyles = {
      padding: "4px 12px",
      fontSize: "12px",
      fontWeight: "600",
      borderRadius: "9999px",
      display: "inline-block",
    };

    let statusStyles = {};

    switch (status) {
      case "Active":
        statusStyles = {
          backgroundColor: "#d1fae5",
          color: "#065f46",
        };
        break;
      case "Paused":
        statusStyles = {
          backgroundColor: "#fef3c7",
          color: "#92400e",
        };
        break;
      case "Draft":
        statusStyles = {
          backgroundColor: "#f3f4f6",
          color: "#374151",
        };
        break;
      default:
        statusStyles = {
          backgroundColor: "#f3f4f6",
          color: "#374151",
        };
    }

    return (
      <span style={{ ...baseStyles, ...statusStyles }}>
        {status}
      </span>
    );
  }

  handlePageChange(newPage, rowsPerPage) {
    this.setState({ currentPage: newPage, rowsPerPage });
  }

  handleRowsPerPageChange(newSize) {
    this.setState({ rowsPerPage: newSize, currentPage: 1 });
  }

  handleDelete(data) {
    this.setState({ selectedCampaign: data, openDeleteConfirm: true });
  }

  handleCancelDelete() {
    this.setState({ openDeleteConfirm: false, deleteProcessing: false });
  }

  handleWindowButtonClick(buttonText) {
    if (buttonText === "Delete") {
      this.handleConfirmDelete();
    } else if (buttonText === "Cancel") {
      this.handleCancelDelete();
    }
  }

  async handleConfirmDelete() {
    this.setState({ deleteProcessing: true });
    try {
      const selectedId = this.state.selectedCampaign &&
        this.state.selectedCampaign.hasOwnProperty('_id') ?
        this.state.selectedCampaign._id : null;
      await this.props.deleteCampaign(selectedId);
      await this.fetchData();
      this.setState({
        openDeleteConfirm: false,
        deleteProcessing: false
      });
      this.props.getToastr("Campaign deleted successfully");
    } catch (error) {
      console.error("Error deleting campaign:", error);
      this.setState({
        deleteProcessing: false
      });
      this.props.getToastr("Error deleting campaign");
    }
  }

  getColumns() {
    const { loadingStates } = this.state;

    return [
      {
        Name: "Name",
        Column: "Name",
        Type: "text",
        flex: 1.5
      },
      {
        Name: "Type",
        Column: "Type",
        Type: "text",
        flex: 1
      },
      {
        Name: "Stores",
        Column: "Stores",
        Type: "custom",
        renderCell: ({ row }) => {
          return (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
              {row.Stores && row.Stores.length > 0 ? (
                row.Stores.map((store, index) => (
                  <span
                    key={index}
                    style={{
                      padding: "2px 8px",
                      backgroundColor: "#dbeafe",
                      color: "#1e40af",
                      borderRadius: "9999px",
                      fontSize: "12px",
                    }}
                  >
                    {store.label}
                  </span>
                ))
              ) : (
                <span style={{ color: "#9ca3af", fontSize: "14px", fontStyle: "italic" }}>
                  - N/A -
                </span>
              )}
            </div>
          );
        },
      },
      {
        Name: "Last Run Date",
        Column: "LastRunDate",
        Type: "custom",
        renderCell: ({ row }) => {
          const lastRun = row && row.hasOwnProperty('LastRunDate') ? row.LastRunDate : null;
          return (
            <div style={{ fontSize: "14px" }}>
              {formatDateTime(lastRun) || "Never Run"}
            </div>
          );
        },
      },
      {
        Name: "Status",
        Column: "Status",
        Type: "custom",
        renderCell: ({ row }) => {
          const status = row && row.hasOwnProperty('Status') ? row.Status : null;
          return this.getStatusBadge(status);
        },
      },
    ];
  }

    onRowButtonClicked = (btn, row) => {

      console.log("264 row click");
    if (btn.Action === "edit") {
 this.props.history.push({
                        pathname:"/home/campaign/create",
                          state: { campaignData: row }
                      });

    }

    if (btn.Action === "delete") {

     this.handleDelete(row);

    }
    if(btn.Action==="custom"){
         const status = row && row.hasOwnProperty('Status') ? row.Status : null;
          let nextStatus = "";

          if (status === "Draft") nextStatus = "Active";
          else if (status === "Active") nextStatus = "Paused";
          else if (status === "Paused") nextStatus = "Active";

          if (nextStatus) {
            const rowId = row && row.hasOwnProperty('_id') ? row._id : null;
            this.handleStatusChange(rowId, nextStatus);
          }
        }
    };

getRowButtons() {
  const { loadingStates } = this.state;

  return [
    {
      ButtonType: "custom",
      Action: "custom",
      renderButton: (row, onButtonClick) => {
        const status = row && row.hasOwnProperty('Status') ? row.Status : null;
        let nextStatus = "";
        
        if (status === "Draft") nextStatus = "Active";
        else if (status === "Active") nextStatus = "Paused";
        else if (status === "Paused") nextStatus = "Active";
        
        if (!nextStatus) return null;
        
        const rowId = row && row.hasOwnProperty('_id') ? row._id : null;
        const isLoading = loadingStates[rowId];
        
        let buttonText = "";
        let buttonClass = {};
        
        if (status === "Draft") {
          buttonText = "Activate";
          buttonClass = {
            backgroundColor: "#10b981",
            border: "none"
          };
        } else if (status === "Active") {
          buttonText = "Pause";
          buttonClass = {
            backgroundColor: "#f59e0b",
            border: "none"
          };
        } else if (status === "Paused") {
          buttonText = "Resume";
          buttonClass = {
            backgroundColor: "#3b82f6",
            border: "none"
          };
        }
        
        return (
          <button
            style={{
              padding: "6px 12px",
              fontSize: "14px",
              color: "#ffffff",
              borderRadius: "8px",
              fontWeight: "500",
              transition: "background-color 0.2s ease",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              opacity: isLoading ? 0.5 : 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
              border: "none",
              cursor: isLoading ? "not-allowed" : "pointer",
              ...buttonClass,
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (!isLoading) {
                onButtonClick("custom", row);
              }
            }}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="animate-spin" style={{ display: "inline-block", width: "14px", height: "14px", border: "2px solid white", borderTop: "2px solid transparent", borderRadius: "50%" }}></span>
                Updating...
              </>
            ) : (
              buttonText
            )}
          </button>
        );
      }
    },
    { 
      ButtonType: "imagebutton",
      Type: "edit", 
      Text: "Edit", 
      Icon: "edit", 
      Action: "edit", 
    },
    { 
      ButtonType: "imagebutton",
      Type: "delete", 
      Text: "Delete", 
      Icon: "delete", 
      Action: "delete" 
    }
  ];
}




  getHeaderButtons() {
    return [
      {
          ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new",
            showInCompact: true,
      }
    ];
  }

  
  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new") {

      this.props.history.push(
        "/home/campaign/create"
      );

    }


  };

  renderDeleteConfirmationModal() {
    const { openDeleteConfirm, selectedCampaign, deleteProcessing } = this.state;

    if (!openDeleteConfirm) return null;

    const windowButtons = [
      {
        Text: "Cancel",
        Type: "secondary",
        Align: "left"
      },
      {
        Text: "Delete",
        Type: "primary",
        Align: "right"
      }
    ];

    const campaignName = selectedCampaign && selectedCampaign.hasOwnProperty('Name') ?
      selectedCampaign.Name : "this campaign";

    return (
      <Window
        header="Delete Campaign"
        size="medium"
         modal={true}
        open={openDeleteConfirm}
        onClose={this.handleCancelDelete}
        onButtonClick={this.handleWindowButtonClick}
        buttons={windowButtons}
        processing={deleteProcessing}
      >
            <div>
              Are you sure you wish to delete <strong style={{ color: "#dc2626" }}>
              {campaignName}
            </strong>
            </div>
      </Window>
    );
  }

  render() {
    const {
      campaigns,
      loading,
      currentPage,
      rowsPerPage,
      totalCount
    } = this.state;

    // Prepare the data for ListingPage
    const rows = campaigns.map((item) => ({
      ...item,
      Name: item.Name,
      Type: item.Type || "N/A",
      LastRun: item.LastRunDate || "Never run",
    }));

    const paginatedRows = rows.slice(
      (currentPage - 1) * rowsPerPage,
      currentPage * rowsPerPage
    );

    const listPageSettings = {
      Title: "Campaigns",
      Columns: this.getColumns(),
      RowButtons: this.getRowButtons(),
      HeaderButtons: this.getHeaderButtons(),
      Search: {
        showSearch: false,
        placeholder: "Search campaigns...",
        onSearch: (searchText) => {
          console.log("Search:", searchText);
        },
        onRefresh: () => this.fetchData(),
      }
    };

    return (
      <>
        <ListingPage
          {...this.props}
          listPageSettings={listPageSettings}
          list={paginatedRows}
          loading={loading}
          totalItemsCount={totalCount}
          itemsCountPerPage={rowsPerPage}
          recordFrom={(currentPage - 1) * rowsPerPage}
          onPageChange={this.handlePageChange}
          onRecordsPerPageCountChange={this.handleRowsPerPageChange}
          onRowButtonClicked={this.onRowButtonClicked}
          onHeaderButtonClicked={this.onHeaderButtonClicked}
          onRowClick={(row) => {

             this.props.history.push({
                        pathname:`/home/campaign/manage/${row._id}`,
                          state: { campaignData: row }
                      });
         

          }}
        />
        {this.renderDeleteConfirmationModal()}
      </>
    );
  }
}

export default CampaignList;